export const appHead = {"link":[{"rel":"icon","type":"image/x-icon","href":"/favicon.ico"},{"rel":"apple-touch-icon","type":"image/x-icon","size":"180x180","href":"/apple-touch-icon.png"},{"rel":"icon","type":"image/png","size":"32x32","href":"/favicon-32x32.png"},{"rel":"icon","type":"image/png","size":"16x16","href":"/favicon-16x16.png"},{"rel":"manifest","href":"/site.webmanifest"},{"rel":"mask-icon","color":"#e05012","href":"/safari-pinned-tab.svg"},{"rel":"msapplication-TileColor","color":"#2b5797"},{"rel":"theme-color","color":"#ffffff"}],"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"name":"format-detection","content":"telephone=no"},{"name":"apple-mobile-web-app-capable","content":"yes"},{"name":"apple-mobile-web-app-status-bar-style","content":"#E05012"},{"name":"apple-mobile-web-app-title","content":"La formation le plus court chemin vers l'emploi."},{"hid":"description","name":"description","content":"La formation le plus court chemin vers l'emploi."},{"hid":"twitter:site","name":"twitter:site","content":"@3ifa"},{"hid":"twitter:card","name":"twitter:card","content":"summary_large_image"},{"hid":"og:site_name","property":"og:site_name","content":"3ifa"},{"hid":"og:url","property":"og:url","content":"https://3ifa.fr"},{"hid":"og:title","property":"og:title","content":"La formation le plus court chemin vers l'emploi."},{"hid":"og:description","property":"og:description","content":"La formation le plus court chemin vers l'emploi."},{"hid":"og:image","property":"og:image","content":"https://3ifa.fr/ifa-ogcard.png"},{"hid":"og:image:secure_url","property":"og:image:secure_url","content":"https://3ifa.fr/ifa-ogcard.png"},{"hid":"twitter:image","name":"twitter:image","content":"https://3ifa.fr/ifa-ogcard.png"},{"hid":"og:image:alt","property":"og:image:alt","content":"La formation le plus court chemin vers l'emploi."},{"property":"og:type","content":"website"}],"style":[],"script":[{"src":"/js/tarteaucitronjs/tarteaucitron.js"}],"noscript":[],"titleTemplate":"%s | sur 3ifa.fr","title":"La formation le plus court chemin vers l'emploi","htmlAttrs":{"lang":"fr"},"bodyAttrs":{"class":["min-w-xs"]}}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const renderJsonPayloads = true

export const componentIslands = true

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"